export default __webpack_public_path__ + "static/media/popup_11-12_novembre.fbf5b2d0.png";